var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "Admin__View" }, [
    _c("div", { staticClass: "Admin__View__Profiles__Header" }, [
      _c("h1", [_vm._v("ניהול קטגוריות שאלות")]),
      _c(
        "div",
        { staticClass: "header-actions" },
        [
          _c(
            "b-button",
            {
              attrs: {
                type: "is-primary",
                "icon-left": "plus",
                disabled: _vm.isCreatingRoot,
              },
              on: { click: _vm.startCreateRootCategory },
            },
            [_vm._v(" צור קטגוריה ראשית ")]
          ),
        ],
        1
      ),
    ]),
    _c(
      "div",
      { staticClass: "Admin__View__Profiles" },
      [
        _vm.isLoading
          ? [
              _c(
                "div",
                { staticClass: "loading-container" },
                [
                  _c("b-loading", {
                    attrs: { "is-full-page": false, "can-cancel": false },
                    model: {
                      value: _vm.isLoading,
                      callback: function ($$v) {
                        _vm.isLoading = $$v
                      },
                      expression: "isLoading",
                    },
                  }),
                ],
                1
              ),
            ]
          : _vm._e(),
        _vm.isCreatingRoot
          ? _c("div", { staticClass: "create-root-section" }, [
              _c("div", { staticClass: "create-root-content" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newRootName,
                      expression: "newRootName",
                    },
                  ],
                  ref: "rootInput",
                  staticClass: "root-input",
                  attrs: {
                    type: "text",
                    placeholder: "שם קטגוריה ראשית חדשה...",
                  },
                  domProps: { value: _vm.newRootName },
                  on: {
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.saveRootCategory.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.cancelCreateRoot.apply(null, arguments)
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.newRootName = $event.target.value
                    },
                  },
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newRootDescription,
                      expression: "newRootDescription",
                    },
                  ],
                  ref: "descriptionInput",
                  staticClass: "root-description-input",
                  attrs: {
                    type: "text",
                    placeholder: "תיאור קטגוריה ראשית חדשה...",
                  },
                  domProps: { value: _vm.newRootDescription },
                  on: {
                    keyup: [
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        )
                          return null
                        return _vm.saveRootCategory.apply(null, arguments)
                      },
                      function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k($event.keyCode, "esc", 27, $event.key, [
                            "Esc",
                            "Escape",
                          ])
                        )
                          return null
                        return _vm.cancelCreateRoot.apply(null, arguments)
                      },
                    ],
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.newRootDescription = $event.target.value
                    },
                  },
                }),
                _c(
                  "div",
                  { staticClass: "root-actions" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { type: "is-success", "icon-left": "check" },
                        on: { click: _vm.saveRootCategory },
                      },
                      [_vm._v(" שמור ")]
                    ),
                    _c(
                      "b-button",
                      {
                        attrs: { type: "is-danger", "icon-left": "close" },
                        on: { click: _vm.cancelCreateRoot },
                      },
                      [_vm._v(" ביטול ")]
                    ),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
        !_vm.isLoading
          ? [
              _vm.categories.length === 0
                ? _c(
                    "div",
                    { staticClass: "no-categories" },
                    [
                      _c("b-icon", {
                        attrs: { icon: "folder-open", size: "is-large" },
                      }),
                      _c("p", [
                        _vm._v(
                          'אין עדיין קטגוריות. לחץ על "צור קטגוריה ראשית" כדי להתחיל.'
                        ),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    { staticClass: "Admin__View__Profiles__Tree" },
                    _vm._l(_vm.categories, function (category) {
                      return _c("TreeItemCRUD", {
                        key: category.id,
                        attrs: { item: category },
                        on: {
                          edit: _vm.handleEdit,
                          "add-child": _vm.handleAddChild,
                          move: _vm.handleMove,
                          delete: _vm.handleDelete,
                        },
                      })
                    }),
                    1
                  ),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }